module.exports = __webpack_public_path__ + "static/media/ougexiaologo.d663392a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/ougexiaologo.png
// module id = 368
// module chunks = 0